import { logError } from './logger';

export const safeJsonParse = (json, context, fallback = {}) => {
  if (json === undefined || json === null || json === '') {
    return fallback;
  }
  if (typeof json === 'object') {
    return json;
  }
  try {
    const parsed = JSON.parse(json);
    return parsed === null ? fallback : parsed;
  } catch (error) {
    logError(`${context}: could not parse JSON`, error, { json });
    return fallback;
  }
};

export const safeJsonStringify = (value, context, fallback = '{}') => {
  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    logError(`${context}: could not serialize value`, error);
    return fallback;
  }
};
